import { Component, Host, h, Method, Element, Listen, Event, Prop } from '@stencil/core';
/**
 * @slot  - Designed to fill sidebar's content.
 */
export class Sidebar {
  constructor() {
    /**
     * If true, the backdrop won't be shown.
     */
    this.hideBackdrop = false;
    /**
     * If true, the sidebar will be shown.
     */
    this.visible = false;
  }
  /**
   * Method to hide the sidebar.
   */
  async hide() {
    this.visible = false;
    this.sySidebarDidHide.emit();
  }
  /**
   * Method to show the sidebar.
   */
  async show() {
    this.visible = true;
    this.sySidebarDidShow.emit();
  }
  /**
   * Method that toggle the sidebar
   */
  async toggle() {
    if (this.visible) {
      this.hide();
    }
    else {
      this.show();
    }
  }
  onKeydown(ev) {
    if (ev.key === 'Escape' && this.visible) {
      this.hide();
    }
  }
  getBackdroprAttributes() {
    const attributes = !this.visible ? { hidden: true } : {};
    return attributes;
  }
  render() {
    return (h(Host, null,
      h("sy-backdrop", Object.assign({}, this.getBackdroprAttributes(), { onClick: () => this.hide() })),
      h("div", { class: "sy-sidebar", style: { visibility: this.visible ? '' : 'hidden' } },
        h("slot", null))));
  }
  static get is() { return "sy-sidebar"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "hideBackdrop": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "If true, the backdrop won't be shown."
      },
      "attribute": "hide-backdrop",
      "reflect": true,
      "defaultValue": "false"
    },
    "visible": {
      "type": "boolean",
      "mutable": true,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "If true, the sidebar will be shown."
      },
      "attribute": "visible",
      "reflect": false,
      "defaultValue": "false"
    }
  }; }
  static get events() { return [{
      "method": "sySidebarDidHide",
      "name": "sySidebarDidHide",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Emitted when the sidebar is hidden."
      },
      "complexType": {
        "original": "void",
        "resolved": "void",
        "references": {}
      }
    }, {
      "method": "sySidebarDidShow",
      "name": "sySidebarDidShow",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Emitted when the sidebar is shown."
      },
      "complexType": {
        "original": "void",
        "resolved": "void",
        "references": {}
      }
    }]; }
  static get methods() { return {
    "hide": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Method to hide the sidebar.",
        "tags": []
      }
    },
    "show": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Method to show the sidebar.",
        "tags": []
      }
    },
    "toggle": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Method that toggle the sidebar",
        "tags": []
      }
    }
  }; }
  static get elementRef() { return "el"; }
  static get listeners() { return [{
      "name": "keydown",
      "method": "onKeydown",
      "target": "window",
      "capture": false,
      "passive": false
    }]; }
}
